import { Observable } from 'rxjs';
import { OrgInfo } from '../models/org/org-info.model';

export abstract class OrgApi {
  abstract getOrgInfo(): Observable<OrgInfo>;
}
